<template>
    <div class="screenfull" @click="click" :title="isFullscreen ? '退出全屏' : '全屏'">
        <i
            :class="[isFullscreen ? 'icon-fullscreen-shrink' : 'icon-fullscreen-expand']"
            class="iconfont screenfull-icon"
        ></i>
    </div>
</template>

<script>
    import screenfull from 'screenfull'

    export default {
        name: 'Screenfull',
        data() {
            return {
                isFullscreen: false
            }
        },
        mounted() {
            this.init()
        },
        beforeDestroy() {
            this.destroy()
        },
        methods: {
            click() {
                if (!screenfull.isEnabled) {
                    this.$message({
                        message: 'you browser can not work',
                        type: 'warning'
                    })
                    return false
                }
                screenfull.toggle()
            },
            change() {
                this.isFullscreen = screenfull.isFullscreen
            },
            init() {
                if (screenfull.isEnabled) {
                    screenfull.on('change', this.change)
                }
            },
            destroy() {
                if (screenfull.isEnabled) {
                    screenfull.off('change', this.change)
                }
            }
        }
    }
</script>

<style scoped>
    .screenfull {
        display: inline-block;
        padding: 0 15px;
        margin-right: 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66 !important;
    }
    .screenfull {
        cursor: pointer;
        transition: background 0.3s;
    }
    .screenfull:hover {
        background: rgba(0, 0, 0, 0.025);
    }
    .index .icon-a-Basic_frontpage {
        color: #5a5e66 !important;
    }
    .screenfull-icon {
        display: inline-block;
        font-size: 16px;
        cursor: pointer;
        color: #5a5e66 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/screenfull.vue